import { AxiosInstance } from 'axios';
import { GroupWorkplaceRepository } from '@/model/repository/shift/GroupWorkplaceRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): GroupWorkplaceRepository => ({
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
